export enum PartnerConfigType {
  LANDING = 'landing',
  DOMAIN = 'domain',
  TITLE = 'title',
  FAVICON = 'favicon',
  LOGO = 'logo',
  TECH_WORKS = 'tech-works',
  SUPPORT_TG = 'support-tg',
  ONLY_DEDIC = 'only-dedic',
  OFFER_EMAIl = 'offer_email',
  PROXYLIST_URL = 'proxylist_url',
  SUPPORT_EMAIL = 'support-email',
  SUPPORT_WEECHAT = 'wechat',
  SUPPORT_WEECHAT_NAME = 'wechat_name',
}
